/* NIGHT OPERATORS: EVERY ADD TO CART OPENS THE CART DRAWER. NEW FILE, 20 Oct 2026 (Bon: "every Add to Cart button on
   the store must open the CART DRAWER, never send the shopper to /cart").
   Loaded once by layout/theme.liquid and layout/theme.pvs-14.liquid.
   1. window.noCartDrawerOpen(addResponse): asks Shopify for the drawer and the cart icon (section rendering), paints
      them into the theme's own <cart-drawer> and opens it, so the shopper stays on the page. If the add response
      already carries the sections it uses them. Only when the theme has no drawer does it fall back to the cart page.
   2. Safety net for browsers with the Navigation API (Chrome, Edge, Android): a SCRIPT navigation to the cart page
      within 6 seconds of a successful /cart/add call becomes the drawer instead. A real click on a cart link is left
      alone. Checkout links are never touched.
   No em or en dashes. */
(function () {
  if (window.noCartDrawerOpen) return;
  var lastAdd = 0;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function cartUrl() { return (window.routes && window.routes.cart_url) || root() + 'cart'; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionList(d) {
    try {
      if (d && typeof d.getSectionsToRender === 'function') {
        var s = d.getSectionsToRender().map(function (x) { return x.section || x.id; }).filter(Boolean);
        if (s.length) return s;
      }
    } catch (e) { /* theme without the method */ }
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  function lastItem(body) {
    if (!body) return null;
    if (body.items && body.items.length) return body.items[body.items.length - 1];
    return body.id ? body : null;
  }
  /* CART-FIX-1028: the theme repaint keeps the drawer switches (shipping insurance, Operator Care) as they were drawn
     on page load, so after an add made by a page script the insurance switch could read ON with no cover in the cart.
     The fresh drawer from Shopify carries the real state: any switch that differs is swapped for the fresh one. */
  function syncUpsells(d, sections) {
    try {
      var html = sections && (sections['cart-drawer'] || sections.CartDrawer);
      if (!html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html');
      Array.prototype.forEach.call(fresh.querySelectorAll('cart-drawer-upsell[data-handle]'), function (f) {
        var h = f.getAttribute('data-handle');
        var cur = d.querySelector('cart-drawer-upsell[data-handle="' + h + '"]');
        if (cur && (cur.getAttribute('data-selected') !== f.getAttribute('data-selected') || cur.getAttribute('data-toggle') !== f.getAttribute('data-toggle'))) {
          cur.replaceWith(document.importNode(f, true));
        }
      });
    } catch (e) { /* leave the drawer as the theme drew it */ }
  }
  function paint(d, sections, body) {
    var state = { sections: sections };
    var it = lastItem(body);
    if (it) { state.id = it.id; state.key = it.key; state.variant_id = it.variant_id; }
    try { d.classList.remove('is-empty'); var inner = d.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty'); } catch (e) { /* ignore */ }
    d.renderContents(state);
    syncUpsells(d, sections);
    setTimeout(function () {
      if (!d.classList.contains('active') && typeof d.open === 'function') { try { d.open(); } catch (e) { /* ignore */ } }
    }, 60);
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) { /* ignore */ }
    try { document.dispatchEvent(new CustomEvent('no:cart-drawer-opened', { bubbles: true, detail: { item: it } })); } catch (e) { /* ignore */ }
    return true;
  }
  window.noCartDrawerOpen = function (addBody) {
    lastAdd = 0;
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') { window.location.href = cartUrl(); return Promise.resolve(false); }
    var ids = sectionList(d);
    if (addBody && addBody.sections && ids.every(function (s) { return addBody.sections[s] != null; })) {
      try { return Promise.resolve(paint(d, addBody.sections, addBody)); } catch (e) { /* fetch fresh below */ }
    }
    return fetch(root() + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('sections ' + r.status); return r.json(); })
      .then(function (sections) { return paint(d, sections, addBody); })
      .catch(function () { window.location.href = cartUrl(); return false; });
  };

  /* note every successful add made by any script on the page */
  if (window.fetch && !window.fetch.__noAtc) {
    var of = window.fetch;
    var wrapped = function (input) {
      var p = of.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(u)) p.then(function (r) { if (r && r.ok) lastAdd = Date.now(); }, function () {});
      } catch (e) { /* ignore */ }
      return p;
    };
    wrapped.__noAtc = true;
    window.fetch = wrapped;
  }

  /* safety net: a script sending the shopper to the cart page right after an add opens the drawer instead */
  try {
    if (window.navigation && typeof window.navigation.addEventListener === 'function') {
      window.navigation.addEventListener('navigate', function (e) {
        try {
          if (!e.cancelable || e.hashChange || e.downloadRequest || e.navigationType !== 'push' && e.navigationType !== 'replace') return;
          if (e.userInitiated) return;
          if (!lastAdd || Date.now() - lastAdd > 6000) return;
          var u = new URL(e.destination.url);
          if (u.origin !== location.origin) return;
          if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(u.pathname)) return;
          if (!drawer()) return;
          e.preventDefault();
          window.noCartDrawerOpen();
        } catch (err) { /* leave the navigation alone */ }
      });
    }
  } catch (e) { /* old browser */ }
})();
